import { useRef } from 'react';

export default function useDebouncedCallback(callback, delay) {
    const timeoutRef = useRef(null);

    const debounced = (...args) => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => callback(...args), delay);
    };

    return debounced;
}